import keyMirror from 'keymirror'

export default keyMirror({
  GET_PORTALS_REQUEST: null,
  GET_PORTALS_SUCCESS: null,
  GET_PORTALS_FAILED: null
})
